import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CoolClimateNavigation.css';

interface CoolClimateNavigationProps {
  onSectionChange: (section: string) => void;
}

export const CoolClimateNavigation: React.FC<CoolClimateNavigationProps> = ({ onSectionChange }) => {
  const navigate = useNavigate();

  const handleSectionChange = (section: string) => {
    if (section === 'home') {
      navigate('/');
    } else if (section === 'coolclimate') {
      navigate('/coolclimate');
    }
  };

  return (
    <nav className="coolclimate-nav-bar">
      <div 
        className="coolclimate-nav-item coolclimate-nav-home"
        onClick={() => handleSectionChange('home')}
      >
        Home
      </div>
      <div 
        className="coolclimate-nav-item coolclimate-nav-calculator active"
        onClick={() => handleSectionChange('coolclimate')}
      >
        CoolClimate Calculator
      </div>
    </nav>
  );
};

